import {
    CREATE_PRINTING_DC_FAILURE_DK,
    CREATE_PRINTING_DC_REQUEST_DK,
    CREATE_PRINTING_DC_SUCCESS_DK,
    CREATE_USER_FORM_PRINTING_DC_DK,
    FETCH_SINGLE_PRINTING_DC_FAILURE_DK,
    FETCH_SINGLE_PRINTING_DC_REQUEST_DK,
    FETCH_SINGLE_PRINTING_DC_SUCCESS_DK,
    FETCH_PRINTING_DC_FAILURE_DK,
    FETCH_PRINTING_DC_REQUEST_DK,
    FETCH_PRINTING_DC_SUCCESS_DK,
    NAVIGATE_PRINTING_DC_DETAILS_DK,
    NAVIGATE_PRINTING_DC_DK,
    PRINTING_DC_USERFORM_RESET_DK,
    UPDATE_PRINTING_DC_FAILURE_DK,
    UPDATE_PRINTING_DC_REQUEST_DK,
    UPDATE_PRINTING_DC_SUCCESS_DK,
    DELETE_PRINTING_DC_REQUEST_DK,
    DELETE_PRINTING_DC_SUCCESS_DK,
    DELETE_PRINTING_DC_FAILURE_DK,
    PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK,
    PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK,
    FETCH_PRINTING_DC_STYLE_REQUEST_DK,
    FETCH_PRINTING_DC_STYLE_SUCCESS_DK,
    FETCH_PRINTING_DC_STYLE_FAILURE_DK,
    FETCH_PRINTING_DC_INVOICE_REQUEST_DK,
    FETCH_PRINTING_DC_INVOICE_SUCCESS_DK,
    FETCH_PRINTING_DC_INVOICE_FAILURE_DK,
    RESET_PRINTING_DC_INVOICE_DK
} from './printingDC.actionsType';

export const PRINTING_DC_DK = 'printingDcDK';

let initialState = {
    loading: false,
    printingDC: [],
    printingDCInvoice: [],
    printingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: false,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0
    },
    selectedPrintingDC: {},
    detailsId: '',
    activeKey: 1,
    isPrintingDC: false,
    printingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: ''
};

export let printingDcDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC_REQUEST_DK:
        case FETCH_PRINTING_DC_INVOICE_REQUEST_DK:
        case FETCH_PRINTING_DC_STYLE_REQUEST_DK:
        case CREATE_PRINTING_DC_REQUEST_DK:
        case FETCH_SINGLE_PRINTING_DC_REQUEST_DK:
        case UPDATE_PRINTING_DC_REQUEST_DK:
        case DELETE_PRINTING_DC_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PRINTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDC: updatePayload
            };
        case FETCH_PRINTING_DC_INVOICE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDCInvoice: updatePayload
            };
        case FETCH_PRINTING_DC_STYLE_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                printingDCStyle: updatePayload?.PONO
            };
        case CREATE_PRINTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_PRINTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: updatePayload,
                userform: updatePayload
            };
        case UPDATE_PRINTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: ''
            };
        case DELETE_PRINTING_DC_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                detailsId: '',
                selectedPrintingDC: {}
            };
        case FETCH_PRINTING_DC_FAILURE_DK:
        case FETCH_PRINTING_DC_INVOICE_FAILURE_DK:
        case FETCH_PRINTING_DC_STYLE_FAILURE_DK:
        case FETCH_SINGLE_PRINTING_DC_FAILURE_DK:
        case CREATE_PRINTING_DC_FAILURE_DK:
        case UPDATE_PRINTING_DC_FAILURE_DK:
        case DELETE_PRINTING_DC_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_PRINTING_DC_INVOICE_DK:
            return {
                ...state,
                printingDCInvoice: []
            };
        case PRINTING_DC_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                selectedPrintingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_PRINTING_DC_DETAILS_DK:
            return {
                ...state,
                isPrintingDC: true,
                printingDCSelectedValue: updatePayload.printingDCSelectedValue
            };
        case NAVIGATE_PRINTING_DC_DK:
            return {
                ...state,
                isPrintingDC: false
            };
        case PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 2
            };
        case PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE_DK:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: false,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
